module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAAAAXNSR0IArs4c6QAAARBJREFUSEvN1r0uBVEUhuH3dTWuAqVSREknOiKRcBVIUFFrFCRqN0CUKj2JUuUvbFnJTHIiZ87M2XsXppvie5KZWftbY0rpFFgGNtRLMi9TSmkku6Ue51h/oTD2gV31ZxpwHBT5c2BdfR+KdUGRvwFW1Nch2CQo8g/AovrUh/VBkX8B5tTHSdgQKPJvwIJ614UNhSIfY7KkXo/DpoHa/DZwpI7OHzlQO2t76ner50KRvwBW1a+4KYEifwvMqx+lUGDPwGwNKLD7fwVVebSY9Dg+RS87Pv+a+lny+Q+a8isayB3gsOSIVDm0VWqkSrFVqdoq5V9lHWUvyBiqmabpNtWTvtXT1dlnzU9EbNarHCQyv/c5q8N5Uu8iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/trusteeCouncil/images/right.png
// module id = NLrD
// module chunks = 0